import {Routes} from '@angular/router';

export const AppRoutes: Routes = [
    {path: 'taker', loadChildren: './taker/taker.module#TakerModule'},
    {path: 'author', loadChildren: './author/author.module#AuthorModule'},
    {path: 'admin', loadChildren: './modules/admin/admin.module#AdminModule'},
    {path: '', loadChildren: './author/author.module#AuthorModule', pathMatch: 'full'}
    // { path: '', component: HomeComponent, pathMatch: 'full'}
];
